import { Dimensions, StyleSheet } from 'react-native';
import { Colors } from 'react-native-paper';
import { appColors } from '../../../assets/styles/global';
import { pixelDimensions } from '../../../config/utils';

const styles = StyleSheet.create({
  baseScroll: {
    marginBottom: pixelDimensions(15),
    marginHorizontal: pixelDimensions(2),
    marginTop: pixelDimensions(2),
  },
  cardPlan: {
    padding: pixelDimensions(2),
    borderRadius: pixelDimensions(2),
    justifyContent: 'center',
  },
  iconAppointment: {
    fontSize: pixelDimensions(7),
    color: Colors.white,
  },
  viewTitleCard: {
    alignSelf: 'center',
  },
  textTitleCard: {
    fontSize: pixelDimensions(5),
    fontFamily: 'MBold',
  },
  textSubTitleCard: {
    fontSize: pixelDimensions(4),
    fontFamily: 'MBold',
    alignSelf: 'center',
  },
  viewContentCard: {
    flexDirection: 'row',
    marginVertical: pixelDimensions(3),
  },
  viewLeftContent: {
    alignItems: 'center',
    justifyContent: 'space-around',
    marginRight: pixelDimensions(2),
    paddingRight: pixelDimensions(2),
    borderColor: Colors.grey300,
    borderRightWidth: 1,

  },
  viewRightContent: {
    justifyContent: 'center',
    alignItems: 'center',
    paddingLeft: pixelDimensions(2),
  },
  buttonAgreement: {
    backgroundColor: appColors.primary,
    paddingVertical: pixelDimensions(3),
    paddingHorizontal: pixelDimensions(4),
  },
  textAgreement: {
    color: Colors.white,
    fontSize: pixelDimensions(3.5),
  },
  viewFooterCard: {
    flexDirection: 'row',
  },
  cardAppointments: {
    padding: pixelDimensions(2),
    marginVertical: pixelDimensions(2),
  },
  buttonAppointments: {
    alignItems: 'center',
    paddingVertical: pixelDimensions(3),
    borderRadius: pixelDimensions(1),
    backgroundColor: appColors.primary,
  },
  cardPayments: {
    padding: pixelDimensions(2),
  },
  titleCardPayments: {
    alignSelf: 'center',
  },
  viewDataBank: {
    paddingHorizontal: pixelDimensions(5),
  },
  viewPaymentConditions: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  buttonTypePayment: {
    backgroundColor: Colors.blueGrey600,
    padding: pixelDimensions(1.25),
    margin: pixelDimensions(1.25),
    borderRadius: pixelDimensions(7),
  },
  buttonTypePaymentSelected: {
    backgroundColor: appColors.primary,
    padding: pixelDimensions(1.25),
    margin: pixelDimensions(1.25),
    borderRadius: pixelDimensions(7),
  },
  textButtonPayment: {
    fontSize: Dimensions.get('window').width < 800 ? pixelDimensions(3.25) : pixelDimensions(2),
    fontWeight: '100',
    color: 'white',
  },
  buttonConfirm: {
    backgroundColor: appColors.primary,
  },
  textPrice: {
    fontSize: pixelDimensions(5),
    textAlign: 'center',
  },
  textPriceValue: {
    fontSize: pixelDimensions(5.5),
    fontFamily: 'MBold',
    textAlign: 'center',
  },
  paragraphTitle: { color: appColors.darkBlue },
  cardTitleText: {
    alignItems: 'center',
    textAlign: 'center',
  },
  viewRowCenter: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },
  textAppointment: {
    fontSize: pixelDimensions(4.5),
    color: Colors.white,
  },
  viewBase: {
    padding: pixelDimensions(5),
  },
  textDayNHour: {
    fontSize: pixelDimensions(5),
    fontFamily: 'MBold',
    marginBottom: pixelDimensions(3),
  },
  buttonBadge: {
    width: pixelDimensions(25),
    height: pixelDimensions(8),
    justifyContent: 'center',
    backgroundColor: Colors.grey700,
    marginBottom: pixelDimensions(2),
  },
  buttonBadgeSelected: {
    backgroundColor: appColors.primary,
  },
  textBadge: {
    color: Colors.white,
    fontFamily: 'MBold',
    textAlign: 'center',
    fontSize: pixelDimensions(4),
    paddingHorizontal: pixelDimensions(2),
  },
  groupButtonsHours: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
  },
  viewPayTypes: {
    marginVertical: pixelDimensions(3),
    flexDirection: 'row',
    justifyContent: 'space-around',
  },
});

export default styles;
